export default {
    empty: {
        title: 'Looking for trend radars?',
        content: 'Create first trend radar.',
        action: 'Create trend radar'
    },
    deprecatedTrends: {
        title: 'Trend radars featuring outdated trends',
        text: 'The following trend radars contain macro-trends that are no longer part of the current Trendone trend universe:',
        recommendation: 'We strongly recommend to copy affected radars and replace outdated trends with their descendants. Affected radars and macro-trends are marked with a red info sign.'
    }
}
